import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Main from './pages/Main';
import AboutUS from './pages/AboutUS';
import WeWork from "./pages/WeWork";
import WebD from "./pages/WebD";
import WebDesign from "./pages/WebDesign";
import AppD from "./pages/AppD";
import SoftwareD from "./pages/SoftwareD";
import CRM from "./pages/CRM";
import GraphcDesign from "./pages/GraphcDesign";
import AI from "./pages/AI";
import SupportMain from "./pages/SupportMain";
import Marketing from "./pages/Marketing";
import Blockchain from "./pages/Blockchain";
import AR from "./pages/AR";
import SaaS from "./pages/SaaS";
import HireResources from "./pages/HireResources";
import DevOps from "./pages/DevOps";
import GameD from "./pages/GameD";
import ContactUs from "./pages/ContactUs";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="aboutus" element={<AboutUS />} />
        <Route path="howwework" element={<WeWork />} />
        <Route path="WebD" element={<WebD/>}/>
        <Route path="WebDesign" element={<WebDesign/>}/>
        <Route path="AppD" element={<AppD/>} />
        <Route path="SoftwareD" element={<SoftwareD/>} />
        <Route path="crm" element={<CRM/>} />
        <Route path="graphicDesign" element={<GraphcDesign/>} />
        <Route path="AIML" element={<AI/>} />
        <Route path="SupportMaintainence" element={<SupportMain/>} />
        <Route path="DigitalMarketing" element={<Marketing/>} />
        <Route path="Blockchain&NFT" element={<Blockchain/>} />
        <Route path="ARVR" element={<AR/>}/>
        <Route path="Saas" element={<SaaS/>}/>
        <Route path="HireResources" element={<HireResources/>} />
        <Route path="DevOps" element={<DevOps/>} />
        <Route path="GameD" element={<GameD/>}/>
        <Route path="ContactUs" element={<ContactUs/>} />
      </Routes>
    </Router>
  );
}

export default App;
